import * as React from "react";
import { Helmet } from "react-helmet";
import { Box, Column, Txt } from "@stenajs-webui/core";

import { PageHeading } from "@stenajs-webui/panels";
import { GapValues } from "@/lib/utils/GapValues";

interface Props {}

export const MissingPageScreen: React.FC<Props> = () => {
  return (
    <>
      <Helmet title="404 - Page not found" />
      <Column display={"flex"} alignItems={"center"}>
        <Box style={{ marginTop: "24px" }}>
          <PageHeading heading={"Page not found"} />
          <Box gap={GapValues.EIGHT}>
            <Txt>If you entered a web address, please check it is correct.</Txt>
            <Txt>
              You can use the menu or search box above to find the information
              you need.
            </Txt>
          </Box>
        </Box>
      </Column>
    </>
  );
};
